import React from 'react';
import { slides } from '../deckSlides';

/** Every slide stacked one-per-page — rendered only when printing to PDF. */
export function PrintDeck() {
  return <div className="print-only" aria-hidden="true" data-id="element-26" data-mp="1zoysarx68xu9">
      {slides.map(slide => {
      const SlideComponent = slide.component;
      return <div key={slide.id} className="print-slide" data-id="element-27" data-mp="28m936c62ukyn">
            <SlideComponent data-id="element-28" data-mp="2mn20t5rodw5z" />
          </div>;
    })}
    </div>;
}